import React,{useContext} from "react";
import { Container,Row, Col } from "react-bootstrap";
import { AffordablePprices, AvailableSvg, EasyBookingSvg, ReliableSvg } from "./HomeSvg";
import { LanguageContext } from "../context/LanguageContext";
const Whyrimlig = () => {
  const { translations } = useContext(LanguageContext);
  return (
    <div className="rm_why_rimlig padding_cmn" id="about">
      <Container>
        <h6 className="rm_subheading text-center">  {translations?.Whyrimlig?.subTitle}</h6>
        <h2 className="subTitle text-center" dangerouslySetInnerHTML={{ __html: translations.Whyrimlig?.title }}>
        </h2>
        <p className="text-center rm_why_text">
        {translations?.Whyrimlig?.description}
        </p>
        <h4 className="text-center">
       {translations?.Whyrimlig?.hilightText}
        </h4>
        <h5 className="text-center"> {translations?.Whyrimlig?.setsHeading}</h5>
        <Row>
            <Col lg={3} sm={6}>
            <div className="service_grid text-center">
                {AffordablePprices}
                <h3 className="text-center">{translations?.Whyrimlig?.setsCards?.affordable}</h3>
                <p className="text-center">{translations?.Whyrimlig?.setsCards?.affordableText}</p>
            </div>
            </Col>
            <Col lg={3} sm={6}>
            <div className="service_grid text-center">
                {AvailableSvg}
                <h3 className="text-center">{translations?.Whyrimlig?.setsCards?.available}</h3>
                <p className="text-center">{translations?.Whyrimlig?.setsCards?.availableText}</p>
            </div>
            </Col>
            <Col lg={3} sm={6}>
            <div className="service_grid text-center">
                {EasyBookingSvg}
                <h3 className="text-center">{translations?.Whyrimlig?.setsCards?.easyBooking}</h3>
                <p className="text-center">{translations?.Whyrimlig?.setsCards?.easyBookingText}</p>
            </div>
            </Col>
            <Col lg={3} sm={6}>
            <div className="service_grid text-center">
                {ReliableSvg}
                <h3 className="text-center"> {translations?.Whyrimlig?.setsCards?.reliableService}</h3>
                <p className="text-center">{translations?.Whyrimlig?.setsCards?.reliableServiceText}</p>
            </div>
            </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whyrimlig;
